export default __webpack_public_path__ + "static/media/adjust-and-control.0408a2c6.svg";